


export default {

  state:{
    preguntas:{
      sintomas:[],
      observaciones:{}
    },

    escalas:{

    }
  },

  mutations: {

    setOncologicaPreguntas(state, data){
      state.preguntas = data;
    },

    setOncologicaEscalas(state, data){
      state.escalas = data;
    }
  }
}

